import { httpUrl } from "./httpUrl";

let baseUrl = `${httpUrl.host}/gy-apartment`;
let baseUrl2 = `${httpUrl.host}/gy-apartment`;
let baseUrl3 = `${httpUrl.host}/gy-apartment`;
let baseUrl4 = `${httpUrl.host}/gy-apartment`;

let api = {
  // 监测点管理——分页
  getFacePointPage: `${baseUrl}/facePoint/getPage`,

  // 监测点管理——添加
  addFacePoint: `${baseUrl}/facePoint/add`,

  // 监测点管理——修改
  updateFacePointPoint: `${baseUrl}/facePoint/update`,

  // 监测点管理——删除
  deleteFacePointPoint: `${baseUrl}/facePoint/deleteByCodes`,

  // 监测点管理——详情
  getFacePointPointByCode: `${baseUrl}/facePoint/getByCode`,

  // 监测点管理——设备列表
  getVideoDeviceList: `${baseUrl2}/videoDevice/getList`,

  // 人脸检测——分页
  getFaceRecordPage: `${baseUrl}/faceRecord/getPage`,

  // 人脸检测——摄像机列表
  getFacePointList: `${baseUrl}/facePoint/getList`,

  // 人脸库管理——分页
  getFaceDBPage: `${baseUrl}/faceDB/getPage`,

  // 人脸库管理——添加
  addFaceDB: `${baseUrl}/faceDB/add`,

  // 人脸库管理——修改
  updateFaceDB: `${baseUrl}/faceDB/update`,

  // 人脸库管理——删除
  deleteFaceDB: `${baseUrl}/faceDB/deleteByCodes`,

  // 人脸库管理——列表
  getFaceDBList: `${baseUrl}/faceDB/getList`,

  // 人脸库管理——一键授权
  authorizeAllFailed: `${baseUrl}/faceAuthorize/authorizeAllFailed`,

  // 黑白名单——分页
  getFaceAuthorizePage: `${baseUrl}/faceAuthorize/getPage`,

  // 黑白名单——人员分页
  getBasicPersonPage: `${baseUrl3}/authority/getPersonPage`,

  // 黑白名单——添加授权
  FaceAuthorizeAdd: `${baseUrl}/faceAuthorize/add`,

  // 黑白名单——修改授权
  FaceAuthorizeModify: `${baseUrl}/faceAuthorize/update`,

  // 黑白名单——详情
  getFaceDBByCode: `${baseUrl}/faceDB/getByCode`,

  // 黑白名单——删除
  deleteFaceAuthorizeByCodes: `${baseUrl}/faceAuthorize/deleteByCodes`,

  // 黑白名单——导出
  exportFaceAuthorize: `${baseUrl}/faceAuthorize/export`,

  // 授权记录——分页
  getAuthorizeRecordPage: `${baseUrl}/authorizeRecord/getPage`,

  // 识别记录——分页
  getIdentifyRecordPage: `${baseUrl}/identifyRecord/getPage`,

  // 授权记录——导出
  exportAuthorizeRecord: `${baseUrl}/authorizeRecord/export`,

  // 识别记录——导出
  exportIdentifyRecord: `${baseUrl}/identifyRecord/export`,

  // 上传图片
  commonUploadImg: `${baseUrl4}/common/uploadImg`,

  // 上传图片
  uploadImg: `${baseUrl4}/yqNews/uploadImg`,

  // 上传图片
  SearchByPicture: `${baseUrl}/searchByPicture`
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/FaceRecognition.js